var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnnounce(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 28,
    rx: 4.5,
    fill: "white",
    stroke: "#DCE0E3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7079 9.65658V20.2317C13.7077 20.5598 13.5917 20.8773 13.3803 21.1283C13.1689 21.3792 12.8757 21.5475 12.5524 21.6036C12.2291 21.6596 11.8964 21.5997 11.613 21.4345C11.3295 21.2692 11.1134 21.0093 11.0028 20.7003L9.30309 15.8316M9.30309 15.8316C8.63113 15.5459 8.07853 15.0376 7.73878 14.3913C7.39903 13.745 7.29301 13.0011 7.43866 12.2856C7.58431 11.5701 7.97269 10.9269 8.53806 10.4649C9.10344 10.0028 9.81109 9.75028 10.5413 9.75H11.9916C15.2374 9.75 18.028 8.77308 19.2496 7.375V18.4583C18.028 17.0603 15.2382 16.0833 11.9916 16.0833H10.5413C10.1158 16.084 9.69469 15.9978 9.30309 15.8316ZM19.2496 15.2917C19.8795 15.2917 20.4836 15.0414 20.929 14.596C21.3744 14.1506 21.6246 13.5466 21.6246 12.9167C21.6246 12.2868 21.3744 11.6827 20.929 11.2373C20.4836 10.7919 19.8795 10.5417 19.2496 10.5417V15.2917Z",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnounce);
export default __webpack_public_path__ + "static/media/announce.89199504eecbbc1478ced6bf7a85eda8.svg";
export { ForwardRef as ReactComponent };